import versions from './versions.json';

export * from './protocol';

export const SUPPORTED_KIT_VERSIONS: readonly number[] = versions.supported;
export const LATEST_KIT_VERSION: number = versions.latest;

// A glob rather than an import: the bundle is a build output, absent until
// `npm run build:kit` runs, and its absence must not break type checks or tests.
const bundles = import.meta.glob<string>('./dist/kit-v*.js', { query: '?raw', import: 'default' });

export const loadKit = (version: number): Promise<string> => {
  const load = bundles[`./dist/kit-v${version}.js`];
  if (!load) return Promise.reject(new Error(`App Kit v${version} is not built; run npm run build:kit`));
  return load();
};

const pageKitBundles = import.meta.glob<string>('./dist/page-kit.js', { query: '?raw', import: 'default' });

export const loadPageKit = (): Promise<string> => {
  const load = pageKitBundles['./dist/page-kit.js'];
  if (!load) return Promise.reject(new Error('The page kit is not built; run npm run build:kit'));
  return load();
};
